import { render, staticRenderFns } from "./template-actions-column.vue?vue&type=template&id=3defc8f5"
import script from "./template-actions-column.vue?vue&type=script&lang=js"
export * from "./template-actions-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports